<script setup lang="ts">
import type { PrimitivesValue } from '../../types/shared'
import { APP_RADIO_KEY } from './constants'

type Props = {
  modelValue: PrimitivesValue
  name: string
}

const props = defineProps<Props>()

const emit = defineEmits(['update:model-value'])

const selectedValue = ref<PrimitivesValue>(props.modelValue)

const updateValue = (newValue: PrimitivesValue) => {
  selectedValue.value = newValue

  emit('update:model-value', newValue)
}

watch(
  () => props.modelValue,
  (newValue) => {
    selectedValue.value = newValue
  },
)

provide(APP_RADIO_KEY, { selectedValue, updateValue, name: props.name })
</script>

<template>
  <div class="app-radio-group" role="radiogroup">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.app-radio-group {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
</style>
